import http from "@/http/aisea/axios";
const resource = "/enterprises/vessels";

export default {

  //動静連絡設定取得
  getConfigurations () {
    return http.get(`${resource}/noon-reports/configurations`);
  },

  //動静連絡バージョン定義全取得
  getVersions () {
    return http.get(`${resource}/noon-reports/versions`);
  },

  //動静連絡検索パラメータ取得
  getSearchParameter () {
    return http.get(`${resource}/noon-reports/search-parameter`);
  },

  //動静連絡一覧取得
  getReports (payload) {

    const params = new URLSearchParams();
    Object.keys(payload).forEach(key => {
      params.append(key, payload[key]);
    })

    return http.get(`${resource}/noon-reports`, { params: params } );
  },

  //動静連絡詳細取得
  getReportDetail (vesselId, reportId) {
    return http.get(`${resource}/${vesselId}/noon-reports/${reportId}`, );
  },

  //動静連絡更新
  updateReport(vesselId, reportId, payload) {
    return http.post(`${resource}/${vesselId}/noon-reports/${reportId}`, payload);
  },

  //動静連絡トランザクション実行
  updateTransaction(vesselId, reportId, transactionId, payload) {
    return http.post(`${resource}/${vesselId}/noon-reports/${reportId}/transaction/${transactionId}`, payload);
  },

};
